var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "472 483 18.696 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #868686;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "business_man",
    "data-name": "business man",
    transform: "translate(692 507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-1",
    d: "M8.261,7.826A3.913,3.913,0,1,0,4.348,3.913,3.913,3.913,0,0,0,8.261,7.826Zm0-.87A3.043,3.043,0,1,0,5.217,3.913,3.043,3.043,0,0,0,8.261,6.957Z",
    transform: "translate(-220 -24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M12.5,10.545a8.376,8.376,0,0,0-4.24-.98c-3.266,0-5.323,1.219-6.469,3.257A7.374,7.374,0,0,0,.984,15.08a7.171,7.171,0,0,0-.1.743c-.011.131-.014.221-.014.264a.435.435,0,0,1-.87,0A6.739,6.739,0,0,1,.13,14.92a8.234,8.234,0,0,1,.9-2.524c1.3-2.31,3.645-3.7,7.227-3.7a8.52,8.52,0,0,1,5.625,1.758q-.2-.019-.408-.019A4.361,4.361,0,0,0,12.5,10.545Z",
    transform: "translate(-220 -24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-1",
    d: "M.87,15.652H9.13v.87H.435Z",
    transform: "translate(-220 -24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-1",
    d: "M13.478,20a5.217,5.217,0,1,0-5.217-5.217A5.217,5.217,0,0,0,13.478,20Zm0-.87A4.348,4.348,0,1,0,9.13,14.783,4.348,4.348,0,0,0,13.478,19.13Z",
    transform: "translate(-220 -24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M13.916,17.49a1.521,1.521,0,0,0,1.064-.814c.435-.919,0-1.566-.931-2.052-.134-.07-.094-.051-.473-.226-.351-.162-.321-.148-.436-.208-.564-.3-.721-.529-.542-.906.219-.464,1.222-.436,1.575-.186l.355.252.5-.709-.355-.252a1.994,1.994,0,0,0-.76-.306V11.3h-.87v.761a1.572,1.572,0,0,0-1.234.848c-.434.916,0,1.565.925,2.048.135.07.1.055.475.227s.32.147.434.207c.569.3.727.531.548.909-.219.464-1.222.436-1.575.186l-.355-.251-.5.709.355.252a2.1,2.1,0,0,0,.93.333v.728h.87Z",
    transform: "translate(-220 -24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterIndustry);
export default __webpack_public_path__ + "static/media/register_industry.c4d8def1b0684d6a2937b552b6e972d3.svg";
export { ForwardRef as ReactComponent };